import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { isProd as defaultIsProd } from "@utils";

const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.grey[100],
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: "6px",
  zIndex: theme.zIndex.drawer + 2,
  whiteSpace: "nowrap",
  position: "absolute",
  left: "50%",
  transform: "translateX(-50%)",
  [theme.breakpoints.down("lg")]: {
    backgroundColor: "transparent",
    borderColor: "transparent"
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}));

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.system[0],
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: "6px",
  color: theme.palette.text[800],
  ...theme.typography.chip,
  [theme.breakpoints.down("lg")]: {
    border: "none",
    backgroundColor: theme.palette.grey[100]
  }
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 1, 0, 0),
  color: theme.palette.text[800],
  [theme.breakpoints.down("lg")]: {
    display: "none"
  }
}));

const DevBanner = ({ isProd = defaultIsProd }) => {
  if (isProd()) return null;

  return (
    <StyledBox data-testid="dev-banner">
      <StyledChip label="Dev Environment" size="small" variant="outlined" />
      <StyledTypography variant="chip">
        No impact on production
      </StyledTypography>
    </StyledBox>
  );
};

export default DevBanner;
